import { ApplicationPlatform } from "@superwall/db/constants"

const DEMAND_SCORE_UNSUPPORTED_PLATFORMS = new Set<ApplicationPlatform>([
  ApplicationPlatform.WEB,
  ApplicationPlatform.STRIPE,
  ApplicationPlatform.WEBAPP,
])

export function isDemandScoreUnsupportedPlatform(
  platform: ApplicationPlatform | undefined
): boolean {
  return platform !== undefined && DEMAND_SCORE_UNSUPPORTED_PLATFORMS.has(platform)
}
